export const CURRENT_URL = `${window.location.protocol}//${window.location.host}`;
import { useState, useEffect } from "react";
import { GridLoader } from "react-spinners";
import { QRCodeCanvas } from "qrcode.react";
import * as Dialog from "@radix-ui/react-dialog";
import * as Form from "@radix-ui/react-form";
import * as RadioGroup from "@radix-ui/react-radio-group";
import * as Separator from "@radix-ui/react-separator";
import { registerAndJoin } from "./apiRoutes/register";
import { CheckCircle, CircleX } from "lucide-react";
import * as Toast from "@radix-ui/react-toast";
import { EyeOff, Eye, RefreshCcw } from "lucide-react";

const query = new URLSearchParams(window.location.search);
const eventId = query.get("event-id");

const regStatuses = {
  success: "success",
  failed: "failed",
};

function WalkInRegistration() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    age: "",
    gender: "",
    email: "",
    phone: "",
    password: "",
    company: "",
    isTermsAndConditionsAccepted: false,
    isSubscribedToNewsletter: true,
  });
  const [eventData, setEventData] = useState({
    adultCount: 0,
    childCount: 0,
  });
  const [processing, setProcessing] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState(0);
  const [bringingSomeone, setBringingSomeone] = useState("no");
  const [isJoinModalOpen, setIsJoinModalOpen] = useState(false);
  const [registerStatus, setRegisterStatus] = useState("");
  const [isAllowed, setIsAllowed] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const isAdmin = !!tmtWalkIn.is_admin;
  const isEventVolunteer = !!tmtWalkIn.is_staff;

  if (!isAdmin && !isEventVolunteer) {
    window.location.href = "portal-login";
    return null;
  }

  useEffect(() => {
    const isAllowed = isAdmin || isEventVolunteer;

    if (!eventId || !isAllowed) {
      window.location.href = CURRENT_URL + "/events";
    }
    setIsAllowed(isAllowed);
    generatePassword();
  }, []);

  const resetData = () => {
    setFormData({
      firstName: "",
      lastName: "",
      age: "",
      gender: "",
      email: "",
      phone: "",
      company: "",
      password: getGeneratedPassword(),
      isTermsAndConditionsAccepted: false,
      isSubscribedToNewsletter: true,
    });
    setEventData({
      adultCount: 0,
      childCount: 0,
    });
    setShowPassword(false);
    setStep(0);
    setBringingSomeone("no");
    setIsJoinModalOpen(false);
  };

  const handleOpenJoinModal = () => setIsJoinModalOpen(true);
  const handleCloseJoinModal = () => setIsJoinModalOpen(false);

  const goNext = () => setStep((prev) => Math.min(prev + 1, 2));
  const goBack = () => setStep((prev) => Math.max(prev - 1, 0));

  const handleToggleTermsCheckbox = () => {
    setFormData((prev) => ({
      ...prev,
      isTermsAndConditionsAccepted: !prev.isTermsAndConditionsAccepted,
    }));
  };

  const handleToggleNewsletterCheckbox = () => {
    setFormData((prev) => ({
      ...prev,
      isSubscribedToNewsletter: !prev.isSubscribedToNewsletter,
    }));
  };

  const handleFormDataChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEventDataChange = (e) => {
    setEventData({ ...eventData, [e.target.name]: e.target.value });
  };

  const handleStep0Click = () => {
    if (bringingSomeone === "yes") {
      goNext();
    } else {
      handleEventRegister();
    }
  };

  const handleEventRegister = async () => {
    setProcessing(true);
    try {
      const response = await registerAndJoin(formData, eventId, eventData);
      setRegisterStatus(regStatuses.success);
      setOpenToast(true);
      resetData();
    } catch (error) {
      const errorMessage = error.message;
      setRegisterStatus(regStatuses.failed);
      setToastMessage(errorMessage);
      setOpenToast(true);
    }
    setProcessing(false);
  };

  const generatePassword = () => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*";

    let pw = "";
    for (let i = 0; i < 10; i++) {
      pw += charset.charAt(Math.floor(Math.random() * charset.length));
    }

    setFormData({ ...formData, password: pw });
  };

  const getGeneratedPassword = () => {
    const charset =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*";

    let pw = "";
    for (let i = 0; i < 10; i++) {
      pw += charset.charAt(Math.floor(Math.random() * charset.length));
    }

    return pw;
  };

  return (
    <div className="walk-in-attendance-container">
      {isAllowed && (
        <Form.Root
          onSubmit={(e) => {
            e.preventDefault();
            handleEventRegister();
            console.log("ay perpek!!💅💅💅");
          }}
        >
          <div className="FormCol">
            <Form.Field name="firstName" className="FormField">
              <Form.Label>First Name*</Form.Label>
              <Form.Control asChild className="FormControl">
                <input
                  type="text"
                  required
                  value={formData.firstName}
                  name="firstName"
                  onChange={handleFormDataChange}
                />
              </Form.Control>
              <Form.Message match="valueMissing" className="FormError">
                First name is required
              </Form.Message>
            </Form.Field>
            <Form.Field name="lastName" className="FormField">
              <Form.Label>Last Name*</Form.Label>
              <Form.Control asChild className="FormControl">
                <input
                  type="text"
                  required
                  value={formData.lastName}
                  name="lastName"
                  onChange={handleFormDataChange}
                />
              </Form.Control>
              <Form.Message match="valueMissing" className="FormError">
                Last name is required
              </Form.Message>
            </Form.Field>
          </div>
          <Form.Field name="emailAddress" className="FormField">
            <Form.Label>Email Address* </Form.Label>
            <Form.Control asChild className="FormControl">
              <input
                type="email"
                required
                value={formData.email}
                name="email"
                onChange={handleFormDataChange}
              />
            </Form.Control>
            <Form.Message match="valueMissing" className="FormError">
              Email address is required
            </Form.Message>
          </Form.Field>
          <Form.Field name="gender" className="FormField">
            <Form.Label htmlFor="genter">Gender*</Form.Label>
            <select
              id="gender"
              required
              value={formData.gender}
              name="gender"
              onChange={handleFormDataChange}
            >
              <option value="prefer_not_to_say">Prefer not to say</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
            <Form.Message match="valueMissing" className="FormError">
              Gender is required
            </Form.Message>
          </Form.Field>
          <Form.Field name="age" className="FormField">
            <Form.Label>Age*</Form.Label>
            <Form.Control asChild className="FormControl">
              <input
                type="number"
                required
                value={formData.age}
                name="age"
                onChange={handleFormDataChange}
              />
            </Form.Control>
            <Form.Message match="valueMissing" className="FormError">
              Age is required
            </Form.Message>
          </Form.Field>
          <Form.Field name="phone" className="FormField">
            <Form.Label>Contact Number</Form.Label>
            <Form.Control asChild className="FormControl">
              <input
                type="tel"
                value={formData.phone}
                name="phone"
                onChange={handleFormDataChange}
              />
            </Form.Control>
          </Form.Field>
          <Form.Field name="company" className="FormField">
            <Form.Label>Company</Form.Label>
            <Form.Control asChild className="FormControl">
              <input
                type="text"
                value={formData.company}
                name="company"
                onChange={handleFormDataChange}
              />
            </Form.Control>
          </Form.Field>
          <Form.Field name="password" className="FormField">
            <Form.Label>Password*</Form.Label>
            <div className="FormPasswordWrapper">
              <Form.Control asChild className="FormControl">
                <input
                  type={showPassword ? "text" : "password"}
                  value={formData.password}
                  onChange={handleFormDataChange}
                />
              </Form.Control>
              <div>
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label="Toggle password visibility"
                  style={{
                    cursor: "pointer",
                    transition: "color 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.color = "#3b82f6")
                  }
                  onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>

                <button
                  type="button"
                  onClick={generatePassword}
                  style={{
                    cursor: "pointer",
                    transition: "color 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.color = "#3b82f6")
                  }
                  onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
                >
                  <RefreshCcw size={20} />
                </button>
              </div>
            </div>
          </Form.Field>
          <p style={{ fontWeight: 400 }}>
            Would you be bringing someone in the event?
          </p>
          <RadioGroup.Root
            onValueChange={setBringingSomeone}
            defaultValue="no"
            className="RadioGroupRoot"
            style={{ marginBottom: "0.25rem" }}
            value={bringingSomeone}
          >
            <div>
              <RadioGroup.Item value="yes" id="accompany-yes">
                <RadioGroup.Indicator className="RadioGroupIndicator" />
              </RadioGroup.Item>
              <label className="RadioLabel" htmlFor="accompany-yes">
                Yes
              </label>
            </div>
            <div>
              <RadioGroup.Item value="no" id="accompany-no">
                <RadioGroup.Indicator className="RadioGroupIndicator" />
              </RadioGroup.Item>
              <label className="RadioLabel" htmlFor="accompany-no">
                No
              </label>
            </div>
          </RadioGroup.Root>
          {bringingSomeone === "yes" && (
            <>
              <Form.Field name="adultCount" className="FormField">
                <Form.Label>Number of Adults*</Form.Label>
                <Form.Control asChild className="FormControl">
                  <input
                    type="number"
                    min={0}
                    value={eventData.adultCount}
                    name="adultCount"
                    onChange={handleEventDataChange}
                  />
                </Form.Control>
                {/* <Form.Message match="valueMissing" className="FormError">
                  Number of adults is required
                </Form.Message> */}
              </Form.Field>
              <Form.Field name="childCount" className="FormField">
                <Form.Label>Number of Children*</Form.Label>
                <Form.Control asChild className="FormControl">
                  <input
                    type="number"
                    min={0}
                    value={eventData.childCount}
                    name="childCount"
                    onChange={handleEventDataChange}
                  />
                </Form.Control>
                {/* <Form.Message match="valueMissing" className="FormError">
                  Number of children is required
                </Form.Message> */}
              </Form.Field>
            </>
          )}
          <div className="checkbox-parent-container">
            {/* <div className="checkbox-container">
              <input
                type="checkbox"
                id="c1"
                name="option1"
                checked={formData.isSubscribedToNewsletter}
                onChange={handleToggleNewsletterCheckbox}
              />
              <label className="Label" htmlFor="c1">
                Subscribe to Newsletter
              </label>
            </div> */}
            <div className="checkbox-container">
              <input
                type="checkbox"
                id="c2"
                name="option2"
                checked={formData.isTermsAndConditionsAccepted}
                onChange={handleToggleTermsCheckbox}
              />
              <label className="Label" htmlFor="c2">
                {/* Accept <a href="">Terms and Conditions.</a> */}
                By signing up for this event, you agree to be added to our
                mailing list for marketing purposes, including future events and
                updates. You may unsubscribe at any time.
              </label>
            </div>
          </div>
          <Form.Submit asChild>
            <button
              className={`ButtonW100 wpem-theme-button ${processing || !formData.isTermsAndConditionsAccepted ? "disabled" : ""}`}
              type="submit"
              disabled={processing || !formData.isTermsAndConditionsAccepted}
            >
              {processing ? "Creating Account..." : "Create Account"}
            </button>
          </Form.Submit>
        </Form.Root>
      )}
      <Dialog.Root open={processing}>
        <Dialog.Portal>
          <Dialog.Overlay
            className="loading-overlay"
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(3px)",
              zIndex: 9999,
            }}
          />
          <Dialog.Content
            className="loading-modal"
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#fff",
              borderRadius: "12px",
              padding: "2rem 2.5rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "1rem",
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              zIndex: 10000,
              textAlign: "center",
            }}
          >
            <GridLoader color="#2563eb" size={12} />
            <h3
              style={{
                fontWeight: 600,
                fontSize: "1.1rem",
                color: "#1e293b",
              }}
            >
              Processing your registration...
            </h3>
            <p style={{ fontSize: "0.9rem", color: "#475569" }}>
              Please wait a moment while we complete your registration.
            </p>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
      <Toast.Provider swipeDirection="right">
        <Toast.Root
          className={`toast-root ${
            registerStatus === regStatuses.success
              ? "toast-success"
              : "toast-error"
          }`}
          open={openToast}
          onOpenChange={setOpenToast}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            {registerStatus === regStatuses.success ? (
              <CheckCircle size={20} />
            ) : (
              <CircleX size={20} />
            )}
            <Toast.Title style={{ fontWeight: 600 }}>
              {registerStatus === regStatuses.success
                ? "Registration Successful!"
                : "Registration Failed"}
            </Toast.Title>
          </div>
          <Toast.Description style={{ fontSize: "0.9rem" }}>
            {registerStatus === regStatuses.success
              ? "Participant has been registered successfully."
              : toastMessage}
          </Toast.Description>
          <Toast.Close className="toast-close">✖</Toast.Close>
        </Toast.Root>

        <Toast.Viewport className="toast-viewport" />
      </Toast.Provider>
    </div>
  );
}

export default WalkInRegistration;
